import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeExternalProps as _mergeExternalProps, mergeProps as _mergeProps, mergeComponentProps as _mergeComponentProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("sidebar-header__root-0srltu", {
  position: "relative",
  zIndex: 1,
  width: "100%"
});
const _staticStyles2 = _cssRef("sidebar-header__chromeband-3b42n9", {
  display: "flex",
  width: "100%",
  justifyContent: "center"
});
const _staticStyles3 = _cssRef("sidebar-header__cappedband-24cs3y", {
  width: "100%",
  maxWidth: "1968px",
  backgroundColor: "var(--system-white)",
  borderBottom: "1px solid var(--system-grey-100)",
  padding: "0 65px",
  "@media (max-width: 1600px)": {
    padding: "0 32px"
  },
  "@media (max-width: 1440px)": {
    padding: "0 16px"
  }
});
const _staticStyles4 = _cssRef("sidebar-header__navlist-3perwg", {
  display: "flex",
  listStyleType: "none",
  justifyContent: "space-between",
  alignItems: "stretch",
  gap: "12px",
  flexWrap: "nowrap",
  width: "100%",
  minWidth: "max-content",
  "@media (max-width: 1200px)": {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gridTemplateRows: "auto auto",
    columnGap: "24px",
    rowGap: "8px",
    gridTemplateAreas: "\"logo cta\" \"menu menu\"",
    paddingTop: 0
  }
});
const _staticStyles5 = _cssRef("sidebar-header__logonavitem-0c7mc1", {
  position: "relative",
  zIndex: 10,
  "@media (max-width: 1200px)": {
    gridArea: "logo",
    display: "flex",
    justifyContent: "flex-start",
    alignSelf: "center"
  }
});
const _staticStyles6 = _cssRef("sidebar-header__logocontainer-2w4icl", {
  display: "flex",
  padding: "11px 0",
  justifyContent: "flex-start",
  height: "125%",
  transition: "0.2s",
  width: "190px",
  willChange: "width",
  ".top-bar &": {
    width: "250px",
    padding: "16px 0",
    "@media (max-width: 1300px)": {
      width: "190px",
      paddingTop: "13px",
      paddingBottom: 0,
      height: "auto"
    }
  },
  ".is-microsite.top-bar &": {
    width: "190px",
    height: "auto"
  },
  ".top-bar .scrolled &": {
    width: "190px",
    padding: "11px 0",
    "@media (max-width: 1200px)": {
      paddingTop: "13px",
      paddingBottom: 0
    }
  },
  "@media (max-width: 1200px)": {
    paddingTop: "13px",
    paddingBottom: 0,
    height: "auto"
  },
  ".is-microsite &": {
    height: "auto",
    width: "190px"
  }
});
const _staticStyles7 = _cssRef("sidebar-header__logolink-1r6orc", {
  alignSelf: "center",
  position: "relative",
  display: "flex",
  alignItems: "center"
});
const _staticStyles8 = _cssRef("sidebar-header__logosvg-2rwq8q", {
  width: "184px",
  height: "auto",
  transition: "0.2s",
  transformOrigin: "bottom left",
  willChange: "transform",
  ".top-bar &": {
    transform: "scale(1.3) translateY(-8px)",
    "@media (max-width: 1300px)": {
      transform: "none"
    }
  },
  ".top-bar .scrolled &": {
    transform: "scale(1)"
  },
  ".is-microsite &": {
    transform: "none"
  }
});
const _staticStyles9 = _cssRef("sidebar-header__menuitemscontainer-0omiai", {
  width: "auto",
  minWidth: 0,
  marginTop: "auto",
  flexShrink: 0,
  "@media (max-width: 1200px)": {
    gridArea: "menu",
    gridRow: "2",
    width: "100%",
    marginTop: "unset",
    alignSelf: "stretch"
  }
});
const _staticStyles0 = _cssRef("sidebar-header__menuitemslist-0dlc4c", {
  display: "flex",
  listStyleType: "none",
  justifyContent: "center",
  alignItems: "stretch",
  gap: "24px",
  width: "auto",
  minWidth: 0,
  height: "54px",
  margin: 0,
  padding: 0,
  willChange: "height",
  transition: "0.2s",
  flexWrap: "nowrap",
  ".top-bar &": {
    height: "66px",
    "@media (max-width: 1200px)": {
      height: "auto",
      minHeight: "54px"
    }
  },
  ".top-bar .scrolled &": {
    height: "54px"
  },
  "@media (max-width: 1200px)": {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: "auto",
    minHeight: "54px",
    flexWrap: "wrap",
    gap: "16px"
  }
});
const _staticStyles1 = _cssRef("sidebar-header__endbarnavitem-0zoav5", {
  position: "relative",
  zIndex: 10,
  "@media (max-width: 1200px)": {
    gridArea: "cta",
    display: "flex",
    justifyContent: "flex-end",
    alignSelf: "start"
  }
});
const _staticStyles10 = _cssRef("sidebar-header__endbarcontainer-0j8ujs", {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  maxWidth: "100%",
  height: "100%",
  padding: "14px 0",
  "@media (max-width: 1200px)": {
    paddingTop: "11px",
    paddingBottom: 0
  }
});
const _staticStyles11 = _cssRef("sidebar-header__endbarcolset-11hsh9", {
  alignItems: "center",
  justifyContent: "flex-end"
});
const _staticStyles12 = _cssRef("sidebar-header__endbarhrcontainer-2kk37a", {
  width: "8px",
  height: "46px"
});
const _staticStyles13 = _cssRef("sidebar-header__endbarhr-2c7zh7", {
  height: "46px",
  display: "block",
  backgroundColor: "var(--system-grey-200)",
  width: "1px"
});
const _staticStyles14 = _cssRef("sidebar-header__navindicator-364jrn", {
  top: "calc(100% - 3px)",
  zIndex: 10,
  display: "flex",
  alignItems: "end",
  justifyContent: "center",
  transition: "300ms ease",
  "&[data-state=\"unset\"]": {
    opacity: 0,
    transform: "translateX(250px)"
  },
  "&[data-state=\"hidden\"]": {
    animation: "static-styles-sidebar-header-kf-187lngad 200ms ease forwards"
  },
  "&[data-state=\"visible\"]": {
    animation: "static-styles-sidebar-header-kf-1fps8usb 200ms ease forwards"
  }
});
const _staticStyles15 = _cssRef("sidebar-header__navindicatoritem-2ffpy2", {
  position: "relative",
  backgroundColor: "var(--primary-orange-500)",
  height: "4px",
  width: "100%",
  borderTopLeftRadius: "3px",
  borderTopRightRadius: "3px"
});
const _staticStyles16 = _cssRef("sidebar-header__viewportoutercontainer-3b42n9", {
  display: "flex",
  width: "100%",
  justifyContent: "center"
});
const _staticStyles17 = _cssRef("sidebar-header__viewportinnercontainer-299iei", {
  perspective: "2000px",
  position: "absolute",
  top: "100%",
  display: "flex",
  width: "100%",
  justifyContent: "flex-end",
  maxWidth: "1313px"
});
const _staticStyles18 = _cssRef("sidebar-header__viewport-22q24a", {
  overflowY: "auto",
  maxHeight: "calc(100vh - 200px)",
  WebkitOverflowScrolling: "touch",
  boxShadow: "0 4px 4px 0px #00000040",
  backgroundColor: "var(--system-white)",
  borderBottomLeftRadius: "4px",
  borderBottomRightRadius: "4px",
  top: "0px",
  position: "relative",
  height: "var(--menu-viewport-height)",
  width: "var(--menu-viewport-width)",
  maxWidth: "1313px",
  transformOrigin: "top center",
  overflowX: "hidden",
  scrollbarGutter: "stable",
  "&[data-state=\"open\"]": {
    minHeight: "422px",
    animation: "static-styles-sidebar-header-kf-1fps8usb 0.3s ease forwards",
    borderTop: "1px solid var(--primary-orange-500)"
  },
  "&[data-state=\"closed\"]": {
    animation: "static-styles-sidebar-header-kf-187lngad 0.3s ease forwards",
    borderTop: "1px solid var(--system-white)"
  },
  "&[data-menu-mode=\"self\"]": {
    transform: "translateX(var(--menu-viewport-self-x))"
  },
  "&[data-menu-mode=\"center\"]": {
    transform: "translateX(var(--menu-viewport-center-x))"
  },
  "@media (max-width: 1200px)": {
    maxHeight: "calc(100vh - 236px)",
    "&[data-menu-mode=\"self\"]": {
      transform: "translateX(0)",
      width: "100%"
    }
  }
});
import React from 'react';
import * as NavigationMenu from '../../primitives/navigation-menu';
import Container from '../../primitives/grid/container';
import { colors } from '../../primitives/colors';
import Link from '../../primitives/link';
import Logo from '../../primitives/logo';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import { useCtaProvider } from '../../../contexts/franchise/cta-provider';
import useSiteNavigation, { type SiteNavigationPrimary } from '../use-site-navigation';
import type { SiteNavigationPrimaryLevel } from '../navigation/site-navigation-types';
import ColSet from '../../primitives/grid/col-set';
import { useLocator } from '../../../contexts/franchise/locator-provider';
import { NATIONAL_CALL_CENTER_DISPLAY, PHONE_NUMBER, PHONE_NUMBER_DISPLAY } from '../../../constants';
import formatPhoneLink from '../../utils/format-phone-link';
import MenuItem from './menu-item';
import StyledDropdown from './styled-dropdown';
import StyledPhoneBlock from './styled-phone-block';
import { breakpoints, rowPadding } from '../../primitives/tokens';
import { EMERGENCY_TAGLINE, HEADER_COMPACT_MENU_ROW_MIN_HEIGHT, HEADER_CONTAINER_OUTER_MAX_PX, HEADER_DROPDOWN_MAX_WIDTH } from './utils';
import hasNavigableHref from '../has-navigable-href';
import useTouchDevice from '../../../hooks/use-touch-device';
import { DROPDOWN_CLOSE_DELAY_MS } from '../../../hooks/use-dropdown-delay';
import { mirrorPrimaryMegaMenuHover, useNavigationContext } from '../../../contexts/navigation-context';
import { filterSiteNavigationPrimaryFromField, filterSiteNavigationPrimaryRootList } from '../utils/filter-navigation-items';
const fadeIn = "static-styles-sidebar-header-kf-1fps8usb";
const fadeOut = "static-styles-sidebar-header-kf-187lngad";
const styles = {
  root: _staticStyles,
  chromeBand: _staticStyles2,
  cappedBand: _staticStyles3,
  navList: _staticStyles4,
  logoNavItem: _staticStyles5,
  logoContainer: _staticStyles6,
  logoLink: _staticStyles7,
  logoSvg: _staticStyles8,
  menuItemsContainer: _staticStyles9,
  menuItemsList: _staticStyles0,
  endBarNavItem: _staticStyles1,
  endBarContainer: _staticStyles10,
  endBarColSet: _staticStyles11,
  endBarHrContainer: _staticStyles12,
  endBarHr: _staticStyles13,
  navIndicator: _staticStyles14,
  navIndicatorItem: _staticStyles15,
  viewportOuterContainer: _staticStyles16,
  viewportInnerContainer: _staticStyles17,
  viewport: _staticStyles18
};
const SidebarHeader = (): JSX.Element => {
  const siteNav = useSiteNavigation();
  const isTouchDevice = useTouchDevice(); // Call once at the top level

  const {
    isLocalCityPage,
    isMicrosite,
    permalink: micrositePermalink,
    franchise: micrositeFranchise
  } = useMicrosite();
  const {
    hideNationalCallCenter,
    hideFranchiseLink,
    overridePhoneNumber,
    overridePhoneNumberDescriptor
  } = useCtaProvider();
  const {
    franchise: locatorFranchise,
    isNationalCallCenter,
    loadingFirst
  } = useLocator();
  const franchise = micrositeFranchise || locatorFranchise?.data;
  const showLocalFranchiseDropdown = franchise && (!hideFranchiseLink && !isMicrosite && !isNationalCallCenter || isLocalCityPage && !hideFranchiseLink);
  const localPhoneReady = !loadingFirst && Boolean(franchise?.mainPhone);
  const franchiseVariantTopItems = React.useMemo(() => filterSiteNavigationPrimaryRootList(siteNav?.primary), [siteNav]);
  const siteNavTabs: SiteNavigationPrimary[] = React.useMemo(() => filterSiteNavigationPrimaryFromField(siteNav?.primary), [siteNav]);
  const useFranchiseResolverPrimary = Boolean(isMicrosite && siteNav);
  const menuKey = React.useMemo(() => {
    if (useFranchiseResolverPrimary) {
      const franchiseId = franchise?.franchiseNumber ?? micrositePermalink ?? 'unknown';
      return `desktop-nav-fr-${franchiseId}-${franchiseVariantTopItems.length}-${franchiseVariantTopItems.map(i => i.title).join('-')}`;
    }
    return `desktop-nav-sn-${siteNavTabs.length}-${siteNavTabs.map(t => t.title).join('-')}`;
  }, [useFranchiseResolverPrimary, franchise?.franchiseNumber, micrositePermalink, franchiseVariantTopItems, siteNavTabs]);
  const {
    dismissSecondaryTopNavDropdown
  } = useNavigationContext();
  const handlePrimaryRegionMouseOver = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    // Synthetic replay from mirrorPrimaryMegaMenuHover bubbles here; ignore to avoid infinite recursion.
    if (!e.nativeEvent.isTrusted) return;
    const {
      relatedTarget,
      currentTarget
    } = e;
    if (relatedTarget instanceof Node && currentTarget.contains(relatedTarget)) {
      return;
    }
    dismissSecondaryTopNavDropdown();
    // Always replay hover on the element under the cursor — relatedTarget is often null/unreliable
    // when crossing the fixed top overlay / transparent hit areas.
    if (e.target instanceof Node) {
      mirrorPrimaryMegaMenuHover(e.target);
    }
  }, [dismissSecondaryTopNavDropdown]);
  return <nav aria-label="Main navigation">
            <NavigationMenu.Root {..._mergeExternalProps({
      css: styles.root,
      key: menuKey,
      rootMouseLeaveDelayMs: DROPDOWN_CLOSE_DELAY_MS,
      "data-sidebar-primary-nav": true,
      onMouseOver: handlePrimaryRegionMouseOver
    })}>
                <div {..._mergeProps({
        css: styles.chromeBand
      })}>
                    <div {..._mergeProps({
          css: styles.cappedBand
        })}>
                        <Container data-sidebar-primary-container>
                            <NavigationMenu.List {..._mergeExternalProps({
              css: styles.navList
            })}>
                                <NavigationMenu.Item {..._mergeExternalProps({
                css: styles.logoNavItem
              })}>
                                    <div {..._mergeProps({
                  css: styles.logoContainer
                })}>
                                        <Link {..._mergeComponentProps({
                    to: isMicrosite && micrositePermalink ? micrositePermalink : '/',
                    css: styles.logoLink,
                    "aria-label": "SERVPRO Home"
                  })}>
                                            <Logo {..._mergeComponentProps({
                      css: styles.logoSvg,
                      "aria-hidden": "true"
                    })} />
                                        </Link>
                                    </div>
                                </NavigationMenu.Item>
                                <li {..._mergeProps({
                css: styles.menuItemsContainer
              })}>
                                    <ul {..._mergeProps({
                  css: styles.menuItemsList
                })}>
                                        {useFranchiseResolverPrimary ? franchiseVariantTopItems.map(tab => {
                    const title = tab.title ?? '';
                    const href = tab.link ?? undefined;
                    const hasValidChildren = Number(tab.items?.length) > 0 && (tab.items ?? []).some((row: SiteNavigationPrimaryLevel | null | undefined) => Boolean(row?.title));
                    if (!title || !href && !hasValidChildren) return null;
                    const suppressIndicator = hasValidChildren && !hasNavigableHref(href);
                    return <NavigationMenu.Item key={title} suppressIndicator={suppressIndicator}>
                                                        <MenuItem tab={tab} isTouchDevice={isTouchDevice} />
                                                    </NavigationMenu.Item>;
                  }) : siteNavTabs.map(tab => {
                    const title = tab.title ?? '';
                    const href = tab.link ?? undefined;
                    const hasValidChildren = Number(tab.items?.length) > 0 && (tab.items ?? []).some((row: SiteNavigationPrimaryLevel | null | undefined) => Boolean(row?.title));
                    if (!title || !href && !hasValidChildren) return null;
                    const suppressIndicator = hasValidChildren && !hasNavigableHref(href);
                    return <NavigationMenu.Item key={title} suppressIndicator={suppressIndicator}>
                                                        <MenuItem tab={tab} isTouchDevice={isTouchDevice} />
                                                    </NavigationMenu.Item>;
                  })}
                                    </ul>
                                </li>
                                <NavigationMenu.Item {..._mergeExternalProps({
                css: styles.endBarNavItem
              })}>
                                    <div {..._mergeProps({
                  css: styles.endBarContainer
                })}>
                                        <ColSet {..._mergeComponentProps({
                    breakpoints: {
                      dt: {
                        between: 12
                      }
                    },
                    css: styles.endBarColSet
                  })}>
                                            <div>
                                                {showLocalFranchiseDropdown && <StyledDropdown text="Your Local SERVPRO" phoneNumber={localPhoneReady ? franchise.mainPhone : undefined} phoneDisplay={localPhoneReady ? franchise.mainPhone : undefined} />}
                                            </div>
                                            <div {..._mergeProps({
                      css: styles.endBarHrContainer
                    })}>
                                                <div>
                                                    {(!hideFranchiseLink && !hideNationalCallCenter && !isMicrosite && !isNationalCallCenter || isLocalCityPage && !hideNationalCallCenter && !hideFranchiseLink) && <hr {..._mergeProps({
                          "aria-hidden": "true",
                          css: styles.endBarHr
                        })} />}
                                                </div>
                                            </div>
                                            <div>
                                                {overridePhoneNumber && overridePhoneNumberDescriptor && <StyledPhoneBlock text={overridePhoneNumberDescriptor} phoneDisplay={overridePhoneNumber} phoneNumber={overridePhoneNumber} />}
                                                {(!hideNationalCallCenter && !isMicrosite || isLocalCityPage && !hideNationalCallCenter) && <StyledPhoneBlock text={NATIONAL_CALL_CENTER_DISPLAY} phoneDisplay={PHONE_NUMBER_DISPLAY} phoneNumber={PHONE_NUMBER} />}
                                                {isMicrosite && franchise && <StyledPhoneBlock text={EMERGENCY_TAGLINE} phoneDisplay={franchise?.tempOutOfService ? PHONE_NUMBER_DISPLAY : formatPhoneLink(franchise.mainPhone)} phoneNumber={franchise?.tempOutOfService ? PHONE_NUMBER : franchise.mainPhone} />}
                                            </div>
                                        </ColSet>
                                    </div>
                                </NavigationMenu.Item>
                                <NavigationMenu.Indicator {..._mergeExternalProps({
                css: styles.navIndicator,
                "aria-hidden": "true"
              })}>
                                    <div {..._mergeProps({
                  css: styles.navIndicatorItem
                })} />
                                </NavigationMenu.Indicator>
                            </NavigationMenu.List>
                        </Container>
                    </div>
                </div>
                <div {..._mergeProps({
        css: styles.viewportOuterContainer
      })}>
                    <div {..._mergeProps({
          css: styles.viewportInnerContainer
        })}>
                        <NavigationMenu.Viewport {..._mergeExternalProps({
            css: styles.viewport,
            "aria-live": "polite"
          })} />
                    </div>
                </div>
            </NavigationMenu.Root>
        </nav>;
};
export default SidebarHeader;